import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { REPEAT_ALL, REPEAT_OFF, REPEAT_ONE } from '../../actions/Playback';
export default function RepeatButton(props) {
    var _a, _b, _c;
    const dispatch = useDispatch();
    const { repeat } = useSelector((state) => state.PlaybackStates);
    const text = (_a = repeat) === null || _a === void 0 ? void 0 : _a.descriptions[repeat.state];
    const variant = ((_b = repeat) === null || _b === void 0 ? void 0 : _b.state) !== 'OFF' ? 'accent' : 'primary';
    const icon = ((_c = repeat) === null || _c === void 0 ? void 0 : _c.state) === 'ONE' ? 'repeatone' : 'repeat';
    if (!repeat) {
        return React.createElement("div", { style: { display: 'none' } });
    }
    return (React.createElement("music-button", { ariaLabelText: text, onClick: handleClick, variant: variant, "icon-name": icon, "icon-only": true, size: props.size || 'small' }));
    function handleClick(e) {
        if (!e.target.disabled && repeat) {
            if (repeat.state === 'OFF') {
                dispatch({ type: REPEAT_ALL });
            }
            else if (repeat.state === 'ALL') {
                dispatch({ type: REPEAT_ONE });
            }
            else {
                dispatch({ type: REPEAT_OFF });
            }
        }
    }
}
;
